import React, { useCallback, useState } from "react";
import ReactDOM from "react-dom";
import {
  FormInstance,
  Button,
  ConfigProvider,
  locales,
  Modal,
} from "@gw/web-basic-components";
import { BusinessConfigProvider } from "..";
import { btnDef } from "../dynamicForm/config";
import DynamicForm from "../dynamicForm";
import type { FormModalConfig } from "./dto";
import styles from "./index.module.less";
/**
 * 表单弹窗服务
 * @deprecated 1.x版本组件，不再维护，请尽快迁移至本地项目
 */
export default function openFormModal(config: FormModalConfig) {
  /**
   * 表单实例
   */
  let currentForm: FormInstance<any> = null;
  let setFormData: (formData: any) => void = null;

  const destroyFns: Array<() => void> = [];
  const div = document.createElement("div");
  document.body.appendChild(div);

  async function handleOk(event, type, renderProps, l) {
    await currentForm.validateFields();
    return new Promise(async (resolve, reject) => {
      if (renderProps.onOk && typeof renderProps.onOk === "function") {
        try {
          console.log(event);

          await renderProps.onOk({ ...event }, type, l);
          resolve("");
        } catch (error) {
          reject(error);
        }
      }
    });
  }

  function handleCancel(event, renderProps?) {
    close([{ triggerCancel: true }]);
    if (
      renderProps &&
      renderProps.onCancel &&
      typeof renderProps.onCancel === "function"
    ) {
      renderProps.onCancel(event);
    }
  }
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  let currentConfig = {
    ...config,
    maskClosable: false,
    close,
    visible: true,
    centered: true,
    footer: null,
  } as any;

  function destroy(...args: any[]) {
    const unmountResult = ReactDOM.unmountComponentAtNode(div);
    if (unmountResult && div.parentNode) {
      div.parentNode.removeChild(div);
    }
    const triggerCancel = args.some((param) => param && param.triggerCancel);
    if (config.onCancel && triggerCancel) {
      config.onCancel.apply(this, args);
    }
    for (let i = 0; i < destroyFns.length; i++) {
      const fn = destroyFns[i];
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      if (fn === close) {
        destroyFns.splice(i, 1);
        break;
      }
    }
  }
  function close(...args: any[]) {
    currentConfig = {
      ...currentConfig,
      visible: false,
      afterClose: () => {
        if (typeof config.afterClose === "function") {
          config.afterClose();
        }
        destroy.apply(this, args);
      },
    };
    render(currentConfig);
  }

  function customExtendsButton() {
    if (config.extendsButton) {
      return config.extendsButton;
    } else {
      return [
        { type: "cancel", label: "取消" },
        { type: "save", label: "确定" },
      ];
    }
  }

  const RenderContent = (props: FormModalConfig) => {
    const {
      record,
      formGroupData,
      formGroupName,
      extendsButton,
      preserve,
      onOk,
      ...restModalProps
    } = props;

    const [, setLoading] = useState<boolean>(false);

    const toggleLoading = useCallback(() => {
      setLoading((prev) => !prev);
    }, []);

    return (
      <ConfigProvider locale={locales.zh_CN}>
        <BusinessConfigProvider {...config.configProvider}>
          <Modal
            wrapClassName={styles["edit-modal-wrapper"]}
            {...restModalProps}
            destroyOnClose
            onCancel={(event) => handleCancel(event, props)}
            footer={
              <div className={styles.footer}>
                {customExtendsButton().map((item) => {
                  return (
                    <Button
                      // loading={loading}
                      key={item.type}
                      type={btnDef.buttonType(item.type)}
                      htmlType={btnDef.buttonHtmlType(item.type)}
                      onClick={async (event) => {
                        if (item.type === "cancel") {
                          handleCancel(event, props);
                        } else {
                          try {
                            update({ loading: true });
                            currentForm.submit();
                            await handleOk(
                              { ...currentForm.getFieldsValue(true) },
                              item.type,
                              props,
                              toggleLoading
                            );
                            update({ loading: false });
                          } catch (error) {
                            update({ loading: false });
                          }
                        }
                      }}
                    >
                      {item.label}
                    </Button>
                  );
                })}
              </div>
            }
          >
            <div className={styles.inner}>
              <DynamicForm
                record={record}
                formGroupData={formGroupData}
                formGroupName={formGroupName}
                extendsButton={extendsButton}
                preserve={preserve}
                onFormReady={(e, b) => {
                  currentForm = e;
                  setFormData = b;
                }}
                onValuesChange={(val, all) => {
                  currentConfig?.onValuesChange?.({
                    val,
                    all,
                    latestData: currentConfig.formGroupData,
                    update,
                    form: currentForm,
                  });
                }}
              />
            </div>
          </Modal>
        </BusinessConfigProvider>
      </ConfigProvider>
    );
  };

  function render(props: any) {
    /**
     * https://github.com/ant-design/ant-design/issues/23623
     *
     * Sync render blocks React event. Let's make this async.
     */
    setTimeout(() => {
      ReactDOM.render(<RenderContent {...props} />, div);
    });
  }

  function update(configUpdate: FormModalConfig) {
    currentConfig = {
      ...currentConfig,
      ...configUpdate,
    };
    render(currentConfig);
  }

  render(currentConfig);

  destroyFns.push(close);

  return {
    destroy: close,
    update,
    // 重置表单
    reset: () => {
      currentForm?.resetFields();
      setFormData(currentConfig.formGroupData);
      update({});
    },
    updateValue: (callback: (form: FormInstance) => void) => {
      callback(currentForm);
    },
  };
}
